import { TicketAccess } from "./../../../models/TicketAccess";
import { GET_TICKET_BY_EXERCISE } from "./../../../api/apiRoutes";
import { Assort } from "../../../models/Assort";
import { Exercise } from "../../../models/Exercise";
import { useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_EXERCISE_BY_DAY } from "../../../api/apiRoutes";
import { format } from "date-fns";
import { setTicketAccessFromExercise } from "../../../models/TicketAccess";

export default function useCalendarSale() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();

  const [exercise, setExercise] = useState<Exercise[]>([]);

  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [tickets, setTickets] = useState<Assort[]>([]);
  const [ticketAccess, setTicketAccess] = useState<TicketAccess>({} as TicketAccess);

  const getExercisesByDay = async (date: Date) => {
    setSelectedDate(date);
    setExercise([]);
    setTicketAccess({} as TicketAccess);
    setTickets([]);
    const formattedDate = format(date, "yyyy-MM-dd");
    const { result, isError } = await get(GET_EXERCISE_BY_DAY(facilityIds, formattedDate));
    if (!isError) {
      setExercise(result);

      if (result.length > 0) {
        let ticketAccessTransform = setTicketAccessFromExercise(
          result[0].objectDb,
          result[0].name,
          result[0].startTime
        );
        setTicketAccess(ticketAccessTransform);
      }
    }
  };

  const getTicketsByExercise = async (id: number, exercise: Exercise) => {
    const exerciseGroupIds = `0,${id}`;

    let ticketAccessTransform = setTicketAccessFromExercise(exercise.objectId, exercise.name, exercise.startTime);
    setTicketAccess(ticketAccessTransform);

    const { result, isError } = await get(GET_TICKET_BY_EXERCISE(facilityIds, exerciseGroupIds));
    if (!isError) {
      setTickets(result);
    }
  };

  return {
    getExercisesByDay,
    getTicketsByExercise,
    exercise,
    selectedDate,
    tickets,
    ticketAccess,
  };
}
